import { ResponsiveLine } from '@nivo/line';
import React from 'react';
import { ChartBase } from 'src/features/boards/components/Analytics/ChartBase';

const formatDate = (date) => {
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${month}/${day}`;
};

const CummulativeChart = ({ data }: { data: any }) => {
  // const dataBar = {
  //   '06/01': {
  //     in_progress: 40,
  //     completed: 115,
  //   },
  //   '06/02': {
  //     in_progress: 50,
  //     completed: 35,
  //   },
  //   '06/03': {
  //     in_progress: 20,
  //     completed: 10,
  //   },
  //   '06/04': {
  //     in_progress: 60,
  //     completed: 40,
  //   },
  // };

  const chartData = data
    ? Object.entries(data).map(([date, values]: any) => ({
        date,
        in_progress: values?.in_progress || 0,
        completed: values?.completed || 0,
        not_started: values?.not_started || 0,
      }))
    : [];

  const dataLine = [
    {
      id: 'not_started',
      color: '#D3DBF8',
      data: chartData.map(({ date, in_progress }) => ({ x: date, y: in_progress })),
    },
    {
      id: 'in_progress',
      color: '#DFF8E3',
      data: chartData.map(({ date, in_progress }) => ({ x: date, y: in_progress })),
    },
    {
      id: 'completed',
      color: '#FFD597',
      data: chartData.map(({ date, completed }) => ({ x: date, y: completed })),
    },
  ];
  const chartObject = [
    {
      type: 'line',
      chart: (
        <ResponsiveLine
          data={dataLine}
          margin={{ top: 50, right: 50, bottom: 50, left: 50 }}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', min: 0, max: 'auto', stacked: false, reverse: false }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -45,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
          }}
          colors={['#D3DBF8', '#DFF8E3', '#FFD597']}
          pointSize={8}
          pointColor={{ theme: 'background' }}
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabel="y"
          pointLabelYOffset={-12}
          useMesh={true}
          enableArea={true}
          areaBaselineValue={0}
          areaOpacity={0.5} // Increase opacity to make the area more opaque
          enableCrosshair={false}
          curve="monotoneX" // Use monotoneX curve for curved lines
          legends={[
            {
              anchor: 'top',
              direction: 'row',
              justify: false,
              translateX: 0,
              translateY: -40,
              itemsSpacing: 2,
              itemDirection: 'left-to-right',
              itemWidth: 80,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: 'circle',
            },
          ]}
        />
      ),
    },
  ];

  return (
    <ChartBase
      data={chartObject}
      noData={chartData.length < 0}
      title="✅&nbsp;Cumulative Flow Diagram (CFD)"
      emptyStateTextArray={[
        'No data to show',
        'Set task estimates and fill timesheet data for accurate burn-up data',
      ]}
      // datepicker={datepicker}
      infoLabel="Calculated based on the task estimates and the timelogs recorded for each task"
    />
  );
};

export default CummulativeChart;
